import { SearchesMixin } from './searches_mixin';
import { TurboMixin } from './turbo_mixin';

/*
Mixin for dynamic record search and payment account select
Required:
- "selectSelectorValue" stimulus value with selector for payment account select
- "turboFrameTagNameValue" stimulus value with turbo frame name
- record id input with wrapper having class "live-search"

Optional:
- "klass" describing searched record class.
  Must be compatible with classes in SearchesMixin
- "additional_turbo_params" method that can be defined in controller
  that returns params added to base payment accounts query
*/

export const PaymentAccountsSearchMixin = (controller) => {
  Object.assign(controller, {
    initialize_payment_accounts_search(klass = 'Needy') {
      TurboMixin(this);
      SearchesMixin(this, klass);

      let selector = null;

      if (this.element.classList.contains('live-search')) {
        selector = this.element;
      } else {
        selector = this.element.querySelector('.live-search');
      }

      this.initializeSearch(
        {
          selector: selector,
          noResultsMessage: 'Nie znaleziono pasujących wyników',
          query: { scope: '', turbo: 'payment_accounts' },
        },
        this.searchCallbacks(),
      );
    },
    searchCallbacks() {
      return {
        onSelect: (result) => {
          const select = document.querySelector(this.selectSelectorValue);

          this.turboGet(result.turbo_url, {
            turbo_frame_table_id: this.turboFrameTagNameValue,
            select_id: select.id,
            ...this.additional_turbo_params?.(),
          });
        },
      };
    },
  });
};
